<template>
  <section class="device_sku_info">
    <h4 class="title">{{ device_sku.sku }}</h4>

    <div class="tab">
      <span class="tab_title" :class="{ active: block === 'parameters' }" @click="block = 'parameters'">
        {{ translate('device_models.params') }}
      </span>
      <span class="tab_title" :class="{ active: block === 'test_config' }" @click="block = 'test_config'">
        {{ translate('device_models.test_config') }}
      </span>
    </div>

    <div v-if="block === 'parameters'" class="parameters">
      <div class="row">
        <div class="col-md-6">
          <fg-input :value="device_sku.sku" :label="translate('device_models.sku')" :readonly="true" />
        </div>
        <div class="col-md-3">
          <fg-input :value="device_sku.radio_module_count" :label="translate('device_models.radio_module_count')" :readonly="true" />
        </div>
        <div class="col-md-3">
          <fg-input :value="models" :label="translate('device_models.models')" :readonly="true" />
        </div>
      </div>
      <div class="row">
        <div class="col-md-3">
          <fg-input :value="device_sku.has_wifi > 0 ? '+' : '-'" :label="translate('device_models.has_wifi')" :readonly="true" />
        </div>
        <div class="col-md-3">
          <fg-input :value="device_sku.has_poe_in > 0 ? '+' : '-'" :label="translate('device_models.has_poe_in')" :readonly="true" />
        </div>
        <div class="col-md-3">
          <fg-input :value="device_sku.has_poe_out > 0 ? '+' : '-'" :label="translate('device_models.has_poe_out')" :readonly="true" />
        </div>
        <div class="col-md-3">
          <fg-input :value="device_sku.ip_protection_class" :label="translate('device_models.ip_protection_class')" :readonly="true" />
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <fg-input :value="clients" :label="translate('device_models.clients')" :readonly="true" />
        </div>
      </div>
    </div>

    <codemirror
        v-else
        class="codemirror card"
        v-model="config"
        :options="{ mode: 'toml', theme: 'neat', lineNumbers: true, tabSize: 2, readOnly: !can_edit }"
    />

    <div class="text-center">
      <span
          v-if="can_edit && config !== (device_sku.test_config || '')"
          class="btn btn-success btn-fill btn-wd marginButton"
          @click.prevent="update_test_config"
      >
        {{ translate('btn.edit') }}
      </span>
      <span class="btn btn-danger btn-fill btn-wd marginButton" @click.prevent="cancel">
        {{ translate('btn.close') }}
      </span>
    </div>
  </section>
</template>

<script>
export default {
  name: 'DeviceSkuInfo',
  props: {
    device_sku: Object,
    can_edit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      block: 'parameters',
      config: ''
    }
  },
  created() {
    this.config = this.device_sku.test_config || ''
  },
  computed: {
    models() {
      return (this.device_sku.device_models || []).map(model => model.model_name).join(', ')
    },
    clients() {
      return (this.device_sku.clients || []).map(client => client.client_name).join(', ')
    }
  },
  methods: {
    update_test_config() {
      if (!this.can_edit) return
      this.$http.v1.putDeviceSku(this.device_sku.id, { config: this.config }, (response) => {
        this.global_notify('info', this.translate('device_models.saved_success'))
        this.$emit('update', response.data)
      })
    },
    cancel() {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
.device_sku_info {
  padding: 10px;
  .title {
    margin: 0 0 10px;
    text-align: center;
  }
  .parameters {
    padding-top: 10px;
  }
  .codemirror {
    height: 500px;
  }
}
</style>
